module.exports = __webpack_public_path__ + "img/scene_jazz_backlight@2x.754ba258.png";